module.exports = __webpack_public_path__ + "img/5.d18725b4.jpg";